import {AnyAction} from 'redux';

import * as at from './text_input_action_types';

const defaultState = {
  text: '',
  isInvalidInput: false,
  submittingCounter: 0,
};

function reducer(state = defaultState, action: AnyAction) {
  switch (action.type) {
    case at.IS_INVALID_INPUT: {
      return {...state, isInvalidInput: action.payload};
    }
    case at.CHANGE_TEXT: {
      return {
        ...state,
        text: action.payload,
      };
    }
    case at.DECREASE_SUBMITTING_COUNTER: {
      return {...state, submittingCounter: state.submittingCounter - 1};
    }
    case at.INCREASE_SUBMITTING_COUNTER: {
      return {...state, submittingCounter: state.submittingCounter + 1};
    }
  }
  return state;
}

export default reducer;
